import "./BehaviorForm.scss"
import React from "react"
import { Prompt } from "react-router"
import AvatarPreview from "./AvatarPreview"
import { AVATAR_CONFIG } from "../../app/constants"
import {
  CreateForm,
  Switch,
  Fieldset,
  MatchUrls,
  RadioGroup,
  RadioButton,
  SelectTimes,
  SubmitButton,
  SelectTimezone,
} from "../../lib"

const schema = {
  avatar_config: {
    label: "Message avatar configuration",
    defaultValue: AVATAR_CONFIG.USER,
    status: "Please allow up to 15 minutes for the image to refresh on your site.",
  },
  hide_messenger: {
    label: "Hide messenger on specific pages",
    placeholder: "/dashboard, http://yoursite.com/splash",
    status: "Please separate urls with commas.",
  },
  hide_urls: {
    label: "Hide messenger when current page url:",
  },
  operating_hours: {
    label: "Enable operating hours",
  },
  hide_offline: {
    label: "Hide messenger when offline",
  },
  timezone: {
    label: "Select your timezone",
    defaultValue: SelectTimezone.guessTimezone(),
  },
  monday: {
    label: "Monday",
  },
  tuesday: {
    label: "Tuesday",
  },
  wednesday: {
    label: "Wednesday",
  },
  thursday: {
    label: "Thursday",
  },
  friday: {
    label: "Friday",
  },
  saturday: {
    label: "Saturday",
  },
  sunday: {
    label: "Sunday",
  },
}

const BehaviorForm = ({
  disabled,
  fieldsData,
  handleSubmit,
  isPristine,
  ...rest
}) => {
  return (
    <form className="BehaviorForm" onSubmit={handleSubmit}>

      <Prompt
        when={!isPristine && !disabled}
        message="You have unsaved changes. Are you sure you want to leave?"
      />

      <Fieldset label="Avatars">
        <AvatarPreview config={fieldsData.avatar_config.value} />
        <RadioGroup {...fieldsData.avatar_config}>
          <RadioButton value={AVATAR_CONFIG.USER}>
            Use Slack user avatar
          </RadioButton>
          <RadioButton value={AVATAR_CONFIG.TEAM}>
            Use Slack team icon
          </RadioButton>
        </RadioGroup>
      </Fieldset>

      <Fieldset label="Visibility">
        <MatchUrls {...fieldsData.hide_urls} />
      </Fieldset>

      <Fieldset label="Operating hours">
        <Switch {...fieldsData.operating_hours} />
        {fieldsData.operating_hours.value &&
          <SelectTimezone {...fieldsData.timezone} />}
        {fieldsData.operating_hours.value &&
          <div className="BehaviorForm_hours">
            <label>Your online schedule</label>
            <SelectTimes {...fieldsData.monday} />
            <SelectTimes {...fieldsData.tuesday} />
            <SelectTimes {...fieldsData.wednesday} />
            <SelectTimes {...fieldsData.thursday} />
            <SelectTimes {...fieldsData.friday} />
            <SelectTimes {...fieldsData.saturday} />
            <SelectTimes {...fieldsData.sunday} />
          </div>}
        {fieldsData.operating_hours.value &&
          <Switch
            {...fieldsData.hide_offline}
            status={
              <p>
                When off, users will receive an automated offline message.
                <br />
                (configure in Appearance)
              </p>
            }
          />}
      </Fieldset>
      <footer>
        <SubmitButton
          className={(isPristine || disabled) && "SubmitButton-hidden"}
          {...rest}>
          Save
        </SubmitButton>
      </footer>
    </form>
  )
}

BehaviorForm.displayName = "BehaviorForm"

export default CreateForm(BehaviorForm, schema)



// WEBPACK FOOTER //
// ./src/channel/behavior/BehaviorForm.js